var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BlockContainer',[_c('div',{staticClass:"flex flex-col flex-grow items-center justify-center font-title uppercase Leading-none text-2-mob lg:text-3-desk"},[_vm._v(" THE PAGE YOU'RE LOOKING FOR ISN'T HERE :-( ")])])}
var staticRenderFns = []

export { render, staticRenderFns }